import { el, on } from '@/lib/dom';

export type ColorOpts = {
  label: string;
  value: string;
  onChange: (hex: string) => void;
  onBegin?: () => void;
  onEnd?: () => void;
};

export function colorControl(opts: ColorOpts): HTMLElement {
  const swatch = el('span', { class: 'co-swatch' });
  swatch.style.background = opts.value;

  const input = el('input', { type: 'color', value: opts.value, ariaLabel: opts.label }) as HTMLInputElement;
  input.className = 'co-input';

  on(input, 'input', () => {
    swatch.style.background = input.value;
    opts.onChange(input.value);
  });
  on(input, 'pointerdown', () => opts.onBegin?.());
  on(input, 'change', () => opts.onEnd?.());

  return el('label', { class: 'co' }, [
    el('div', { class: 'sl-row' }, [
      el('span', { class: 'sl-label' }, [opts.label]),
      el('span', { class: 'sl-val mono' }, [opts.value.toLowerCase()]),
    ]),
    el('div', { class: 'co-row' }, [swatch, input]),
  ]);
}
